/**
 * Social navigation component
 * 
 */

import React, { PureComponent } from 'react';

// Functions

import Event from '../../utils/functions/analytics';

export default class Social extends PureComponent {

	handleClick(event) {
		
		Event.navigation({ action: 'social', label: event.currentTarget.firstElementChild.textContent });
		Event.outbound({ action: 'social', label: event.currentTarget.href });
	}

	render() {

		const { className } = this.props;
		const { facebook_url, twitter_url, linkedin_url, google_url, youtube_url, instagram_url, pinterest_url, behance_url, dribbble_url, github_url, line_url, rss_url } = this.props.data;

		const name = 'nav nav-social ' + className;

		return (

			<ul className={name}>
				{ !! facebook_url && <li className="nav-item"><a href={facebook_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-facebook">Facebook</i></a></li> }
	            { !! behance_url && <li className="nav-item"><a href={behance_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-behance">Behance</i></a></li> }
	            { !! dribbble_url && <li className="nav-item"><a href={dribbble_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-dribbble">Dribbble</i></a></li> }
	            { !! github_url && <li className="nav-item"><a href={github_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-github">GitHub</i></a></li> }
	            { !! pinterest_url && <li className="nav-item"><a href={pinterest_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-pinterest">Pinterest</i></a></li> }
	            { !! linkedin_url && <li className="nav-item"><a href={linkedin_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-linkedin">LinkedIn</i></a></li> }
	            { !! twitter_url && <li className="nav-item"><a href={twitter_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-twitter">Twitter</i></a></li> }
	        	{ !! google_url && <li className="nav-item"><a href={google_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-google">Google+</i></a></li> }
	        	{ !! youtube_url && <li className="nav-item"><a href={youtube_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-youtube">YouTube</i></a></li> }
	        	{ !! instagram_url && <li className="nav-item"><a href={instagram_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-instagram">Instagram</i></a></li> }
	        	{ !! line_url && <li className="nav-item"><a href={line_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-line">Line</i></a></li> }
	        	{ !! rss_url && <li className="nav-item"><a href={rss_url} className="nav-link" target="_blank" onClick={this.handleClick}><i className="icon i-social-rss">RSS</i></a></li> }
	        </ul>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/social/social.js